import moment from 'moment'

export function validatorPayDay(rule, value, callback) {
  const min = 1
  const max = 31
  const errorText = '缴款日超过最大值限制：31'
  if ((value >= min && value <= max) || value === '') {
    callback()
  }
  callback(new Error(errorText))
}

export function validatorPresentDays(rule, value, callback) {
  const days = moment(this.leaseInfoParams.startStopDate[1]).diff(this.leaseInfoParams.startStopDate[0], 'day') + 1

  if (days >= value) {
    callback()
  }

  callback(new Error('赠送天数不得超过租赁总天数'))
}
